<template>
  <v-card class="mb-4">
    <v-card-text>
      <v-row dense>
        <v-col cols="12" md="3">
          <v-text-field
            v-model.trim="searchFields.ponumber"
            label="PO Number"
            density="compact"
            hide-details
            clearable
            @keyup.enter="handleSearch"
          ></v-text-field>
        </v-col>
        
        <v-col cols="12" md="3">
          <v-text-field
            v-model.trim="searchFields.itemnumber"
            label="Item Number"
            density="compact"
            hide-details
            clearable
            @keyup.enter="handleSearch"
          ></v-text-field>
        </v-col>
        
        <v-col cols="12" md="3">
          <v-text-field
            v-model.trim="searchFields.buyerid"
            label="Buyer ID"
            density="compact"
            hide-details
            clearable
            @keyup.enter="handleSearch"
          ></v-text-field>
        </v-col>
        
        <v-col cols="12" md="3">
          <v-text-field
            v-model.trim="searchFields.shippingname"
            label="Buyer Name"
            density="compact"
            hide-details
            clearable
            @keyup.enter="handleSearch"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        
        <v-col cols="12" md="3">
          <v-text-field
            v-model.trim="searchFields.trackingnumber"
            label="Tracking #"
            density="compact"
            hide-details
            clearable
            @keyup.enter="handleSearch"
          ></v-text-field>
        </v-col>
        
        <v-col cols="12" md="3">
          <v-text-field
            v-model.trim="searchFields.shippingstreet1"
            label="Shipping Street 1"
            density="compact"
            hide-details
            clearable
            @keyup.enter="handleSearch"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field
            v-model.trim="searchFields.ebayorderid"
            label="eBay Order Num"
            density="compact"
            hide-details
            clearable
            @keyup.enter="handleSearch"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field
            v-model.trim="searchFields.listingid"
            label="Listing Id"
            density="compact"
            hide-details
            clearable
            @keyup.enter="handleSearch"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-checkbox
            color="error"
            v-model="searchFields.deleted"
            label="Search deleted sales"
            density="compact"
            hide-details
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row dense class="mb-4 mt-4">
        <v-col cols="12" md="3">
          <div class="d-flex flex-column">
            <div class="mb-2">
              Sale: ${{ searchFields.sale[0] }} - ${{ searchFields.sale[1] }}
            </div>
            <v-range-slider
              v-model="searchFields.sale"
              :min="0"
              :max="1000"
              :step="10"
              hide-details
              density="compact"
              class="ml-1"
              color="primary"
            >
              <template v-slot:prepend>
                <v-text-field
                  v-model.number="searchFields.sale[0]"
                  type="number"
                  density="compact"
                  hide-details
                  style="width: 60px"
                  @change="handlePriceInput('sale', 0, $event)"
                ></v-text-field>
              </template>
              <template v-slot:append>
                <v-text-field
                  v-model.number="searchFields.sale[1]"
                  type="number"
                  density="compact"
                  hide-details
                  style="width: 60px"
                  @change="handlePriceInput('sale', 1, $event)"
                ></v-text-field>
              </template>
            </v-range-slider>
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <div class="d-flex flex-column">
            <div class="mb-2">
              Cost: ${{ searchFields.cost[0] }} - ${{ searchFields.cost[1] }}
            </div>
            <v-range-slider
              v-model="searchFields.cost"
              :min="0"
              :max="1000"
              :step="10"
              hide-details
              density="compact"
              class="ml-1"
              color="primary"
            >
              <template v-slot:prepend>
                <v-text-field
                  v-model.number="searchFields.cost[0]"
                  type="number"
                  density="compact"
                  hide-details
                  style="width: 60px"
                  @change="handlePriceInput('cost', 0, $event)"
                ></v-text-field>
              </template>
              <template v-slot:append>
                <v-text-field
                  v-model.number="searchFields.cost[1]"
                  type="number"
                  density="compact"
                  hide-details
                  style="width: 60px"
                  @change="handlePriceInput('cost', 1, $event)"
                ></v-text-field>
              </template>
            </v-range-slider>
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <div class="d-flex flex-column">
            <div class="mb-2">
              Shipping: ${{ searchFields.shipping[0] }} - ${{ searchFields.shipping[1] }}
            </div>
            <v-range-slider
              v-model="searchFields.shipping"
              :min="0"
              :max="100"
              :step="1"
              hide-details
              density="compact"
              class="ml-1"
              color="primary"
            >
              <template v-slot:prepend>
                <v-text-field
                  v-model.number="searchFields.shipping[0]"
                  type="number"
                  density="compact"
                  hide-details
                  style="width: 60px"
                  @change="handlePriceInput('shipping', 0, $event)"
                ></v-text-field>
              </template>
              <template v-slot:append>
                <v-text-field
                  v-model.number="searchFields.shipping[1]"
                  type="number"
                  density="compact"
                  hide-details
                  style="width: 60px"
                  @change="handlePriceInput('shipping', 1, $event)"
                ></v-text-field>
              </template>
            </v-range-slider>
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <div class="d-flex flex-column">
            <div class="mb-2">
              Profit: ${{ searchFields.profit[0] }} - ${{ searchFields.profit[1] }}
            </div>
            <v-range-slider
              v-model="searchFields.profit"
              :min="-100"
              :max="500"
              :step="5"
              hide-details
              density="compact"
              class="ml-1"
              color="primary"
              strict
            >
              <template v-slot:prepend>
                <v-text-field
                  v-model.number="searchFields.profit[0]"
                  type="number"
                  density="compact"
                  hide-details
                  style="width: 60px"
                  @change="handlePriceInput('profit', 0, $event)"
                ></v-text-field>
              </template>
              <template v-slot:append>
                <v-text-field
                  v-model.number="searchFields.profit[1]"
                  type="number"
                  density="compact"
                  hide-details
                  style="width: 60px"
                  @change="handlePriceInput('profit', 1, $event)"
                ></v-text-field>
              </template>
            </v-range-slider>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-2" dense>
        <v-col cols="12" class="d-flex align-center">
          <v-chip-group
            v-model="activeFilters"
            column
            multiple
          >
            <v-chip
              v-for="(value, key) in activeSearchFields"
              :key="key"
              closable
              @click:close="clearField(key)"
            >
              {{ getFieldLabel(key) }}<span v-if="key !== 'deleted'">: {{ value }}</span>
            </v-chip>
          </v-chip-group>
          
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="handleSearch"
            class="ml-2"
          >
            Search
          </v-btn>
          <v-btn
            color="secondary"
            :disabled="!hasActiveFilters"
            @click="clearAllFields"
            class="ml-2"
          >
            Clear All
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed } from 'vue'
import debounce from 'lodash/debounce'

const props = defineProps({
  initialValues: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['search'])

const searchFields = ref({
  ponumber: '',
  itemnumber: '',
  buyerid: '',
  shippingname: '',
  trackingnumber: '',
  shippingstreet1: '',
  sale: [0, 1000],
  cost: [0, 1000],
  shipping: [0, 100],
  profit: [-100, 500],
  ebayorderid: '',
  listingid: '',
  deleted: false
})

// Initialize search fields with URL values
props.initialValues.forEach(([key, value]) => {
  if (key in searchFields.value) {
    if (['sale', 'cost', 'shipping', 'profit'].includes(key)) {
      searchFields.value[key] = value.split('-').map(Number)
    } else if (key === 'deleted') {
      searchFields.value[key] = value === 'true'
    } else {
      searchFields.value[key] = value
    }
  }
})

const finalSearchFields = ref(JSON.stringify(searchFields.value))

const fieldLabels = {
  ponumber: 'PO Number',
  itemnumber: 'Item Number',
  buyerid: 'Buyer ID',
  shippingname: 'Buyer Name',
  trackingnumber: 'Tracking #',
  shippingstreet1: 'Shipping Street 1',
  sale: 'Sale',
  cost: 'Cost',
  shipping: 'Shipping',
  profit: 'Profit',
  ebayorderid: 'eBay Order Num',
  listingid: 'Listing Id',
  deleted: 'Deleted'
}

const getFieldLabel = (key) => fieldLabels[key]

const activeSearchFields = computed(() => {
  return Object.entries(JSON.parse(finalSearchFields.value))
    .filter(([key, value]) => {
      if (['sale', 'cost'].includes(key)) {
        return value[0] > 0 || value[1] < 1000
      } else if (key === 'shipping') {
        return value[0] > 0 || value[1] < 100
      } else if (key === 'profit') {
        return value[0] > -100 || value[1] < 500
      } else if (key === 'deleted') {
        return value === true
      }
      return (value||'').trim() !== ''
    })
    .reduce((acc, [key, value]) => {
      const isDefault = (
        ((key === 'sale' || key === 'cost') && value[0] === 0 && value[1] === 1000) ||
        (key === 'shipping' && value[0] === 0 && value[1] === 100) ||
        (key === 'profit' && value[0] === -100 && value[1] === 500)
      )
      if (!isDefault && ['sale', 'cost', 'shipping', 'profit'].includes(key)) {
        acc[key] = value[0] + '-' + value[1]
      } else {
        acc[key] = value
      }
      return acc
    }, {})
})

const hasActiveFilters = computed(() => {
  return Object.values(searchFields.value).some(value => (value||'').toString().trim() !== '')
})

const clearField = (field) => {
  if (['sale', 'cost'].includes(field)) {
    searchFields.value[field] = [0, 1000]
  } else if (field === 'shipping') {
    searchFields.value[field] = [0, 100]
  } else if (field === 'profit') {
    searchFields.value[field] = [-100, 500]
  } else {
    searchFields.value[field] = ''
  }
  emitSearch()
}

const clearAllFields = () => {
  Object.keys(searchFields.value).forEach(key => {
    if (['sale', 'cost'].includes(key)) {
      searchFields.value[key] = [0, 1000]
    } else if (key === 'shipping') {
      searchFields.value[key] = [0, 100]
    } else if (key === 'profit') {
      searchFields.value[key] = [-100, 500]
    } else {
      searchFields.value[key] = ''
    }
  })
  emitSearch()
}

const emitSearch = debounce(() => {
  if (JSON.stringify(searchFields.value) !== finalSearchFields.value) {
    finalSearchFields.value = JSON.stringify(searchFields.value)
    emit('search', activeSearchFields.value)
  }
}, 300)

const handleSearch = () => {
  emitSearch()
}

const handlePriceInput = (field, index, event) => {
  const value = Number(event.target.value)
  if (isNaN(value)) return
  
  const newRange = [...searchFields.value[field]]
  newRange[index] = Math.min(Math.max(value, 0), 10000)
  
  // Ensure min <= max
  if (index === 0 && newRange[0] > newRange[1]) {
    newRange[0] = newRange[1]
  } else if (index === 1 && newRange[1] < newRange[0]) {
    newRange[1] = newRange[0]
  }
  
  searchFields.value[field] = newRange
  // handleSearch()
}
</script> 

<style>
.v-range-slider .v-field__input{
    padding-right: 0px !important;
}
</style>